import { UI_LANGUAGES, useI18n, type UiLanguage } from './index.tsx';
import { languageOptionLabel } from './languageName.ts';

/**
 * Sits in the header, reachable from every screen — including the call, where
 * someone who picked the wrong language should not have to leave to fix it.
 */
export function LanguagePicker() {
  const { language, setLanguage, t } = useI18n();

  return (
    <label className="lang-picker">
      <span className="visually-hidden">{t.common.interfaceLanguage}</span>
      <select
        // The accessible name is translated, so it changes the moment this
        // control is used. Tests need a handle that does not move.
        data-testid="ui-language"
        value={language}
        aria-label={t.common.interfaceLanguage}
        onChange={(e) => setLanguage(e.target.value as UiLanguage)}
      >
        {UI_LANGUAGES.map((code) => (
          <option key={code} value={code}>
            {languageOptionLabel(code, language)}
          </option>
        ))}
      </select>
    </label>
  );
}
